let player_videos;

function onYouTubePlayerAPIReady() {
  var first_video_id = document.querySelector("#first_video_id").innerHTML;

  player_videos = new YT.Player('video-placeholder', {
    width: 850,
    height: 480,
    videoId: first_video_id,
    playerVars: {
      color: 'white',
      controls: 1,
      loop: 1,
      showinfo: 0,
      rel: 1,
    },
    events: {
      'onReady': onPlayerReady,
      'onStateChange': onPlayerStateChange
    }
  });

  function onPlayerReady(event) {
    event.target.mute();
    // count++;
    // console.log(count +":"+ formatTime(event.target.getDuration()));
    // $(".duration_"+count).text(formatTime(event.target.getDuration()));
    // console.log(event.target.getDuration());
  }

  function onPlayerStateChange(event) {
    if (event.data == YT.PlayerState.PLAYING) {
      event.target.mute();
    }
  }

  function formatTime(time) {
    time = Math.round(time);
    var minutes = Math.floor(time / 60),
      seconds = time - minutes * 60;
    seconds = seconds < 10 ? '0' + seconds : seconds;
    return minutes + ":" + seconds;
  }
}

(function () {
  var tag = document.createElement('script');
  tag.src = 'https://www.youtube.com/player_api?' + Math.random();
  var firstScriptTag = document.getElementsByTagName('script')[0];
  firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
  var mp4video = $('#video-placemp4');
  var popwindow = $('.popup-window');
  var youtubevideo = $('.video-placeholder-wapper');
  $('.video_wrapindex').click(function () {
    var type = $(this).attr('data-video');
    var url = $(this).attr('data-video-id');
    var adr = $(this).attr('data-video-address');
    var page_url = $(this).attr('data-page');
    if (type == 'youtube' && url != '') {
      mp4video.hide();
      player_videos.cueVideoById(url);
      youtubevideo.show();
      popwindow.show();
    } else if (type == 'mp4' && adr != '') {
      mp4video.prop('src', adr);
      youtubevideo.hide();
      mp4video.show();
      popwindow.show();
    } else if (type == 'page' && page_url != '') {
      console.log(page_url);
      window.open(page_url, '_blank');
    }
  });

  $('.popup-bg').click(function () {
    popwindow.hide();
    mp4video.prop('src', '');
    player_videos.pauseVideo();
  });
  $('.btn-close-popup').click(function () {
    popwindow.hide();
    mp4video.prop('src', '');
    player_videos.pauseVideo();
  });

  //left nav click change right content
  $('.parentnav').click(function () {
    $('.parentnav').removeClass('parentactive');
    $(this).addClass('parentactive');
    var nameid = $(this).attr('data-id');
    $('.mainpage').siblings().removeClass('active').hide().siblings(`${nameid}`).addClass('active').show();
    $('.faq-search-text').val('');
  });

  //left nav
  $('.grid-sider-faq')
    .find('.nav-name')
    .click(function () {
      if ($(this).next('.nav-subcontent').is(':hidden')) {
        $(this).addClass('faq-active');
      } else {
        $(this).removeClass('faq-active');
      }
      $(this).next('.nav-subcontent').slideToggle();
    });

  $('.group')
    .find('h6')
    .click(function () {
      if ($(this).next('.group-dropdown').is(':hidden')) {
        $(this).addClass('dropdown-active');
      } else {
        $(this).removeClass('dropdown-active');
      }
      $(this).next('.group-dropdown').slideToggle();
    });
})();
